// Velopaths partner model: Business Partners and Trail Partners share one portal.
export const PARTNER_TYPES = {
  business: {
    label: "Business Partner",
    categories: [
      { value: "bike_shop", label: "Bike Shop" },
      { value: "rental_operator", label: "Rental Operator" },
      { value: "tour_company", label: "Tour Company" },
    ],
  },
  trail: {
    label: "Trail Partner",
    categories: [
      { value: "local_cyclist", label: "Local Cyclist" },
      { value: "cycling_club", label: "Cycling Club" },
      { value: "trail_advocate", label: "Trail Advocate" },
      { value: "nonprofit", label: "Nonprofit" },
      { value: "tourism_org", label: "Tourism Organization" },
    ],
  },
};

export const PARTNER_TYPE_LABEL = { business: "Business Partner", trail: "Trail Partner" };

export const PARTNER_CATEGORY_LABEL = Object.fromEntries(
  Object.values(PARTNER_TYPES).flatMap((t) => t.categories.map((c) => [c.value, c.label]))
);
